/**
 * Phone API
 * Phone.com SMS operations
 */

import { crmPost } from './crmConfig';

/**
 * Send SMS message to a lead (new contact)
 * @param {Object} data - { to: string, text: string }
 */
export const sendSMS = async (data) => {
  const response = await crmPost('/api/phone/messages/new/sendsms', data);
  return response.data;
};

/**
 * Send SMS message to an existing patient.
 * Hits the same controller as `sendSMS` but with `:patientStatus = existing`
 * so the backend matches against the PatientProfile collection.
 * @param {Object} data - { to: string, text: string }
 */
export const sendPatientSMS = async (data) => {
  const response = await crmPost('/api/phone/messages/existing/sendsms', data);
  return response.data;
};
